import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/waves.scss';
import View from '../view';

function createInternalWaves(length, size) {
  const itemStyle = {
    width: size,
    height: size
  };

  return Array.apply(null, { length: length }).map((value, index) => (
    <View className={styles.waveItem} key={index} style={itemStyle} />
  ));
}

function Waves(props) {
  if (__NATIVE__) {
    return <View />;
  }
  const { className, color, size, waves } = props;
  const wrapClasses = classNames([styles.wrapWaves, className]);

  const waveItems = createInternalWaves(waves, size);
  return (
    <View className={wrapClasses} data-color={color}>
      {waveItems}
    </View>
  );
}

Waves.displayName = 'Waves';

Waves.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  color: PropTypes.string,
  size: PropTypes.number,
  waves: PropTypes.number
};

Waves.defaultProps = {
  color: 'brand-primary',
  waves: 2,
  size: 50
};

export default Waves;
